import {styled} from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import {Chip} from '@mui/material';

const SRoot = styled('div')(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

const SGroup = styled('div')(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

const SChip = styled(Chip)(({theme}) => ({
  height: 'auto',
  minWidth: 24,
  padding: theme.spacing(1, 2),
}));

export const CounterTooltip = ({
  total,
  groups,
}: {
  total: string;
  groups: Array<{
    title: string;
    count?: number;
  }>;
}) => {
  return (
    <SRoot>
      <Typography variant='body3Bold'>{total}</Typography>
      {groups
        .filter(group => !!group.count)
        .map(({title, count}) => {
          return (
            <SGroup key={title}>
              <Typography variant='body3'>{title}:</Typography>
              <SChip label={count} />
            </SGroup>
          );
        })}
    </SRoot>
  );
};
